"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var types_1 = require("../../../../types");

var procedures_1 = require("../../../../procedures");

var SubModule_1 = require("../../SubModule");

var PolymathError_1 = require("../../../../PolymathError");
/**
 * Namespace that handles all Count Restriction related functionality
 */


var CountRestrictions =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(CountRestrictions, _SubModule_1$SubModul);

  function CountRestrictions() {
    var _this;

    _classCallCheck(this, CountRestrictions);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CountRestrictions).apply(this, arguments));
    /**
     * Modify the maximum amount of tokenholders allowed to hold the token at once
     *
     * @param args.maxHolderCount - limit to the amount of concurrent tokenholders
     */

    _this.modifyMaxHolderCount = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                procedure = new procedures_1.ModifyMaxHolderCount(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Retrieve the maximum amonut of tokenholders allowed to hold the token at once
     * Can be modified with `modifyMaxHolderCount`
     */


    _this.getMaxHolderCount = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var contractWrappers, securityToken, symbol, countTransferManagerModule;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                _context2.next = 4;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.CountTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 4:
                countTransferManagerModule = _context2.sent[0];

                if (countTransferManagerModule) {
                  _context2.next = 7;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FeatureNotEnabled,
                  message: 'You must enable the TokenholderCountRestrictions Feature'
                });

              case 7:
                return _context2.abrupt("return", countTransferManagerModule.maxHolderCount());

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    return _this;
  }

  return CountRestrictions;
}(SubModule_1.SubModule);

exports.CountRestrictions = CountRestrictions;